import React from "react";
import { Loader } from "@certa/blocks";
import { useIntl } from "react-intl";
import { FilePreviewer as FilePreviewComp } from "@certa/filepreviewer";
import { Dialog } from "@certa/catalyst/components/Dialog";
import styles from "./FilePreviewer.module.css";
import { getFileType } from "@certa/common/utils/file";
import {
  fileDownload,
  FileDownloadTypes
} from "@certa/common/utils/fileDownload";

export type FilePreviewerProps = {
  visible: boolean;
  closeModal: () => void;
  fileName: string;
  url: string;
  loading?: boolean;
};

const FilePreviewer = (props: FilePreviewerProps) => {
  const intl = useIntl();
  const {
    visible: isVisible,
    url,
    fileName,
    closeModal,
    loading: isLoading
  } = props;
  const fileType = isLoading ? "" : getFileType(fileName);
  const isPdf = fileType === "pdf";

  const onDownload = () => {
    fileDownload({
      downloadType: FileDownloadTypes.FILE_DOWNLOAD,
      url,
      fileName
    });
    closeModal();
  };

  const filePreviewBody = () => {
    return (
      <div className={styles.previewWrapper}>
        <FilePreviewComp
          url={url}
          disablePreview={isPdf && !url.includes("file_hash")}
          fileName={fileName}
        />
      </div>
    );
  };

  return (
    <Dialog
      title={intl.formatMessage({
        id: "filePreviewer.previewFile"
      })}
      showCloseIcon={false}
      show={isVisible}
      onPrimaryAction={onDownload}
      onSecondaryAction={closeModal}
      secondaryActionText={intl.formatMessage({
        id: "filePreviewer.closeButton"
      })}
      primaryActionText={intl.formatMessage({
        id: "filePreviewer.downloadButton"
      })}
      maxWidth="80%"
      minWidth={isPdf ? "75vw" : "520px"}
    >
      {isLoading ? (
        <div className={styles.loaderWrapper}>
          <Loader />
        </div>
      ) : (
        filePreviewBody()
      )}
    </Dialog>
  );
};
FilePreviewer.defaultProps = {
  loading: false
};
export { FilePreviewer };
